import { analytics } from '@play-co/gcinstant';
import { Pet } from 'src/replicant/buruburu/pet';
import { TutorialStep } from 'src/replicant/buruburu/tutorial/tutorial.ruleset';
import { Visit } from 'src/replicant/visit';
import user from 'src/state/user';
import StateObserver from 'src/StateObserver';
import { showTutorial } from '../tutorial.util';
import { TutorialEvent } from '../TutorialController';
import { TutorialHandler } from './TutorialHandler';
import PopupMonitor from 'src/game/logic/PopupMonitor';

export class PetSickTutorial implements TutorialHandler {
  public readonly step: TutorialStep = 'petsGetSick';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    const conversationStepAnalytics = {
      $stepIndex: 5,
      $stepName: 'got_sick',
    };

    // Prevent double tutorial popup from being opened when pet gets sick for the first time
    // This is not the best solution, but it's probably the easiest one
    if (PopupMonitor.isOpen('popupTutorialStep')) {
      return false;
    }

    if (event === 'conversationStarted') {
      analytics.pushEvent('TutorialStepStart', conversationStepAnalytics);
      return true;
    }

    if (event === 'conversationFinished') {
      const { user } = StateObserver.getState();

      const isVisiting = Visit.getters(user).isVisiting();
      const petState = Pet.getters(user).getPetState(
        StateObserver.now(),
        isVisiting,
      );
      if (petState !== 'sick' && petState !== 'tooth_decay') {
        return false;
      }

      analytics.pushEvent('TutorialStepFinish', conversationStepAnalytics);

      await showTutorial('petsGetSick', {
        $stepIndex: 6,
        $stepName: 'pets_get_sick_popup',
      });
      return true;
    }

    return false;
  }
}
